<template>
    <main class="smaller-padding data-table">
        <v-data-table
            :headers="headers"
            :items="list"
            :loading="loading"
            :hide-actions="true"
            :must-sort="true"
            :no-data-text="$t('message.generics.message.noData')"
            :no-results-text="$t('message.generics.message.noData')"
            sort-icon="mdi-chevron-down"
            ref="table"
        >
            <v-progress-linear
                slot="progress"
                :color="providerColor"
                indeterminate
            />

            <template slot="items" slot-scope="props">
                <app-connections-table-item
                    :data-item="props.item"
                    @change="refreshConnections()"
                >
                </app-connections-table-item>
            </template>
        </v-data-table>

        <infinite-loading :identifier="infiniteId" @infinite="load">
            <div slot="no-results"></div>
            <div slot="no-more"></div>
        </infinite-loading>
    </main>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import AppConnectionsTableItem from "./components/ConnectionsTableItem";
import EventBus from "@packages/event-bus/index";
import provider from "@mixins/provider";

export default {
    components: {
        AppConnectionsTableItem,
        InfiniteLoading,
    },

    data() {
        return {
            list: [],
            entity: "connections",
            page: 0,
            infiniteId: +new Date(),
            loading: false,
        };
    },

    watch: {
        filters() {
            this.refreshConnections();
        },
    },

    computed: {
        filters() {
            if (!this.entity) throw new Error("Entity not specified");

            return this.$store.state[this.entity].filters;
        },
        headers() {
            return [
                { text: "", value: "", sortable: false },
                {
                    text: this.$t("message.connections.message.device"),
                    value: "nomeAparelho",
                    sortable: false,
                },
                {
                    text: this.$t("message.connections.message.identification"),
                    value: "email",
                    sortable: false,
                },
                //  {text: 'Hostname', value: 'hostname'},
                {
                    text: this.$t("message.generics.message.ip"),
                    value: "ipv4",
                    sortable: false,
                },
                {
                    text: this.$t("message.connections.message.mac"),
                    value: "macAddress",
                    sortable: false,
                },
                {
                    text: this.$t("message.connections.message.timeLeft"),
                    value: "expireDate",
                    sortable: false,
                },
            ];
        },
    },

    mixins: [provider],

    methods: {
        async load($state) {
            this.loading = true;

            try {
                const { content, totalElements } =
                    await this.$api.connections.list({
                        page: this.page,
                        filters: this.filters,
                    });

                if (content.length !== 0) {
                    this.list.push(...content);
                    this.page++;
                    $state.loaded();

                    if (this.list.length >= totalElements) {
                        $state.complete();
                    }
                } else {
                    $state.complete();
                }

                const count = totalElements || 0;

                this.$store.commit("CONNECTIONS_SET_COUNT", count);
            } catch (error) {
                console.log(error);
                //error
            } finally {
                this.loading = false;
            }
        },
        async refreshConnections() {
            this.page = 0;
            this.list = [];
            this.infiniteId++;
        },
        isTabUnknown() {
            return this.$store.state.connections.filters.unknown == true;
        },
    },

    mounted() {
        EventBus.$on("load-connections", this.refreshConnections);
    },

    beforeDestroy() {
        EventBus.$off("load-connections", this.refreshConnections);
    },
    mixins: [],
};
</script>

<style scoped></style>
